import { useState, type ReactNode } from "react";
import { apiBase, setToken } from "../api";

export default function TokenGate({ children }: { children: ReactNode }) {
  const [value, setValue] = useState("");
  const [saved, setSaved] = useState(Boolean(localStorage.getItem("jh_token")));

  if (saved) return <>{children}</>;

  return (
    <div style={{ maxWidth: 420, margin: "15vh auto", padding: "0 16px" }}>
      <h2>JobHunter</h2>
      <p className="muted">
        Enter the Worker API token to connect to Cloudflare D1. Set{" "}
        <code>VITE_API_BASE</code> to your Worker URL (default{" "}
        <code>{apiBase()}</code>).
      </p>
      <input
        type="password"
        placeholder="JOBHUNTER_API_TOKEN"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()}
      />
      <button className="primary" style={{ marginTop: 12 }} onClick={save}>
        Connect
      </button>
    </div>
  );

  function save() {
    if (!value.trim()) return;
    setToken(value.trim());
    setSaved(true);
  }
}